<template>
  <div :class="[baseCss, disabled ? ['disabled', 'pointer-events-none'] : null, readonly ? ['cursor-default'] : null]">
    <ul @mouseout="out()" :class="[readonly ? null : 'cursor-pointer', 'whitespace-nowrap']">
      <li v-for="(box, index) in boxes" :key="index" @click="select(index)" @mouseover="over(index)" :aria-labelledby="index" :class="['inline-block', 'align-middle']">
        <icon :provider="iconProvider" :size="size" :class="[box.selected ? null : 'bcq-rating-box-off', box.tempSelected ? 'bcq-rating-box-off-no-filter' : null, dense ? null : 'p-1', 'transition-all', 'duration-300']" :color="color" :color-lightness="colorLightness" :name="icon" />
      </li>
    </ul>
  </div>
</template>
<script>
import methods from '../../mixins/methods'
import props from '../../mixins/props'

export default {
  name: 'Rating',
  mixins: [
    props,
    methods
  ],
  data () {
    return {
      boxes: [],
      baseCss: this.componentBaseCss('rating', ['select-none', 'inline-block', 'align-middle'])
    }
  },
  model: {
    prop: 'value',
    event: 'input'
  },
  props: {
    name: {
      type: String,
      required: true
    },
    value: {},
    size: {
      type: Number,
      default: 2
    },
    readonly: {
      type: Boolean
    },
    disabled: {
      type: Boolean
    },
    items: {
      type: Number,
      default: 5
    },
    icon: {
      type: String,
      default: 'star'
    },
    color: {
      type: String,
      default: 'yellow'
    },
    colorLightness: {
      type: Number,
      default: 500
    },
    dense: {
      type: Boolean
    }
  },
  mounted () {
    this.onMounted()
  },
  methods: {
    onMounted () {
      const score = Math.round((this.value / 100 * this.items) * 10).toFixed(2)
      for (let index = 0; index < this.items; index++) {
        this.boxes.push({
          selected: score > index,
          value: index + 1,
          tempSelected: false
        })
      }
    },
    over (index) {
      if (this.readonly || this.disabled) {
        return
      }
      this.boxes.forEach((box, i) => {
        if (i <= index) {
          box.tempSelected = true
        }
      })
    },
    out () {
      if (this.readonly || this.disabled) {
        return
      }
      this.boxes.forEach(box => {
        if (!box.selected) {
          box.tempSelected = false
        }
      })
    },
    select (index) {
      const boxes = this.boxes
      if (this.readonly || this.disabled) {
        return
      }
      boxes.forEach((box, i) => {
        box.selected = i <= index
      })
      this.out(index)
      this.$emit('input', {
        name: this.name,
        value: boxes[index].value
      })
    }
  }
}
</script>
<style>
.bcq-rating .bcq-rating-box-off
{
  filter: grayscale(100%);
  opacity: .5;
}

.bcq-rating .bcq-rating-box-off-no-filter
{
  filter: none;
  opacity: 1;
}
</style>



// WEBPACK FOOTER //
// src/bcq-ui/components/rating/rating.vue